import { registerSW } from 'virtual:pwa-register'

// https://github.com/antfu/vite-plugin-pwa/blob/main/src/client/build/register.ts
const updateSW = registerSW({

  onNeedRefresh () {
    // App update is available. Don't force-reload immediately (kills open IDB connections).
    // Instead, activate the new SW silently the next time the page is hidden
    // (tab switch, home screen, navigation away) — safe because no IDB writes are in-flight.
    // After the new SW takes control with updated asset hashes, reload on next visibility so
    // that stale chunk URLs in the running JS don't cause dynamic import failures
    // (e.g. "TypeError: 'text/html' is not a valid JavaScript MIME type").
    console.log('[SW] Waiting for page to be hidden to update to new version')
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        console.log('[SW] Updating version in background')
        updateSW(true)
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            window.location.reload()
          }
        }, { once: true })
      }
    }, { once: true })
  },
  onOfflineReady () {
    console.log('[SW] You are ready to work offline')
  },
  onRegistered () {
    console.log('[SW] onRegistered')
  },
  onRegisterError (e) {
    console.log('[SW] onRegisterError', e)
  }
})
